import { useMemo } from 'react';

import { DebouncedSearchBox } from '@g17eco/molecules/search/DebouncedSearchBox';

import { EvidenceType } from '../../types/emissions';
import { EVIDENCE_TYPE_OPTIONS } from '../../utils/evidenceDisplay';
import { FilterSelect, type FilterSelectOption } from '../FilterSelect';
import { SORT_LABELS, type SortKey } from './librarySort';

interface ToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  evidenceType: EvidenceType | '';
  onEvidenceTypeChange: (value: EvidenceType | '') => void;
  fileType: string;
  onFileTypeChange: (value: string) => void;
  fileTypeOptions: string[];
  sort: SortKey;
  onSortChange: (value: SortKey) => void;
}

const CATEGORY_OPTIONS: FilterSelectOption[] = [
  { value: '', label: 'All categories' },
  ...EVIDENCE_TYPE_OPTIONS,
];

const SORT_OPTIONS: FilterSelectOption[] = (Object.keys(SORT_LABELS) as SortKey[]).map((key) => ({
  value: key,
  label: SORT_LABELS[key],
}));

export const Toolbar = ({
  search,
  onSearchChange,
  evidenceType,
  onEvidenceTypeChange,
  fileType,
  onFileTypeChange,
  fileTypeOptions,
  sort,
  onSortChange,
}: ToolbarProps) => {
  const fileTypeOptionsList = useMemo<FilterSelectOption[]>(
    () => [{ value: '', label: 'All types' }, ...fileTypeOptions.map((ext) => ({ value: ext, label: ext }))],
    [fileTypeOptions],
  );

  return (
    <div className='tw:flex tw:flex-wrap tw:items-center tw:gap-2'>
      <div className='tw:flex-grow tw:min-w-[200px] tw:max-w-[400px]'>
        <DebouncedSearchBox
          defaultText={search}
          onTextChange={onSearchChange}
          placeholder='Search by filename or tag…'
        />
      </div>
      <FilterSelect
        value={evidenceType}
        options={CATEGORY_OPTIONS}
        onSelect={(next) => onEvidenceTypeChange((next as EvidenceType) || '')}
        triggerClassName='tw:w-40'
      />
      <FilterSelect
        value={fileType}
        options={fileTypeOptionsList}
        onSelect={onFileTypeChange}
        triggerClassName='tw:w-32'
      />
      <div className='tw:flex-grow' />
      <FilterSelect
        value={sort}
        options={SORT_OPTIONS}
        onSelect={(next) => onSortChange(next as SortKey)}
        triggerClassName='tw:w-40'
      />
    </div>
  );
};
